import { render } from "./Feedbacks.vue?vue&type=template&id=58f342dc"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"

import "./Feedbacks.vue?vue&type=style&index=0&id=58f342dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__